/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconStickyNotes/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconStickyNotes({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconStickyNotes",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconStickyNotes.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1LARSI': alignSelf,'--mt-2-Z1LARSI': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1LARSI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1LARSI': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1LARSI': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1LARSI': opacity,'--w-10-Z1LARSI': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1LARSI': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1LARSI': isAnimated ? animation : "none",'--sd-8-Z1LARSI': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1LARSI': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconStickyNotes.SvgPath"
  data-view-path={viewPath}
 d="M19 5v9h-5v5H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2zm-7 11H7v-2h5v2zm5-4H7V8h10v2z"
 style={{'--f-12-Z1LARSI': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}